/**
 * AI 配置 Context
 * 用于在 SKU 详情页面中共享当前的 AI 配置状态
 */

import React, { createContext, useContext, useState } from 'react';
import { UserPreference } from '../types/ai-analysis-types';

interface AIConfigContextType {
  currentConfig: UserPreference | null;
  setCurrentConfig: (config: UserPreference | null) => void;
  configId: number | undefined;
}

const AIConfigContext = createContext<AIConfigContextType | undefined>(undefined);

export const AIConfigProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [currentConfig, setCurrentConfig] = useState<UserPreference | null>(null);

  const contextValue: AIConfigContextType = {
    currentConfig,
    setCurrentConfig,
    configId: currentConfig?.id,
  };

  return (
    <AIConfigContext.Provider value={contextValue}>
      {children}
    </AIConfigContext.Provider>
  );
};

export const useAIConfig = () => {
  const context = useContext(AIConfigContext);
  if (context === undefined) {
    throw new Error('useAIConfig must be used within AIConfigProvider');
  }
  return context;
};

